// extracted by mini-css-extract-plugin
export default {"sideNav":"FixedSidebar_sideNav__E2JUK","sideIcons":"FixedSidebar_sideIcons__UXHvd","sideBarWrapper":"FixedSidebar_sideBarWrapper__aY-qB"};